import { render, staticRenderFns } from "./projectControl.vue?vue&type=template&id=fadca9fe&scoped=true&"
import script from "./projectControl.vue?vue&type=script&lang=js&"
export * from "./projectControl.vue?vue&type=script&lang=js&"
import style0 from "./projectControl.vue?vue&type=style&index=0&id=fadca9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadca9fe",
  null
  
)

component.options.__file = "projectControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VSelect,
  VSwitch,
  VTextField,
})
